<div [formGroup]="formGroup">
    <input type="number"
           min="0"
           max="23"
           formControlName="hour"
           (keypress)="onKeyPressHour($event)" />
    &nbsp;:&nbsp;
    <input type="number"
           min="0"
           max="59"
           formControlName="minute"
           (keypress)="onKeyPressMinute($event)" />
</div>
